module.exports = __webpack_public_path__ + "83bb81aababd69f99af8ea9d55e247cb.svg";